Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;
var _reactNative = require("react-native-web");
var _styles = require("../../styles");
var _reactNativeSafeAreaContext = require("react-native-safe-area-context");
var useStyles = exports.useStyles = function useStyles() {
  var _STYLES$useStyles = _styles.STYLES.useStyles(),
    COLORS = _STYLES$useStyles.COLORS,
    spacing = _STYLES$useStyles.spacing,
    bp = _STYLES$useStyles.bp,
    sizing = _STYLES$useStyles.sizing;
  var insets = (0, _reactNativeSafeAreaContext.useSafeAreaInsets)();
  var container = {
    width: '100%',
    marginTop: -insets.top,
    height: sizing.topBarHeightDefault + insets.top,
    paddingTop: insets.top,
    paddingLeft: spacing.page.padding.paddingLeft,
    paddingRight: spacing.page.padding.paddingRight,
    position: 'relative'
  };
  var background = {
    position: 'absolute',
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    backgroundColor: COLORS.white
  };
  var topBar = {
    height: sizing.topBarHeightDefault,
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    maxWidth: _styles.STYLES.grid.maxContentWidth,
    width: '100%',
    alignSelf: 'center',
    paddingLeft: (0, _styles.getREM)(3.3125),
    paddingRight: (0, _styles.getREM)(3.3125)
  };
  var backButton = {
    position: 'absolute',
    top: 0,
    left: 0,
    height: '100%',
    justifyContent: 'center'
  };
  var logo = {
    width: 142,
    height: 35
  };
  if (bp.is([bp.tablet, bp.desktop])) {
    logo.width = 192;
    logo.height = 46;
  }
  var logoLink = {
    width: logo.width,
    height: logo.height,
    marginTop: 15
  };
  if (bp.is([bp.tablet, bp.desktop])) {
    logoLink.marginTop = 5;
  }
  var styles = _reactNative.StyleSheet.create({
    container: container,
    background: background,
    topBar: topBar,
    backButton: backButton,
    logo: logo,
    logoLink: logoLink
  });
  return {
    styles: styles
  };
};